import { Badge } from '@/components/ui/badge';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  icon: React.ReactNode;
  title: string;
  description: string;
  disabled: boolean;
  route: string;
}

export default function CardSection({
  icon,
  title,
  description,
  disabled,
  route,
}: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation('common')

  return (
    <div
      className={`bg-[#18181b] hover:card-blur p-4 rounded-xl min-h-[132px] ${
        disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'
      }`}
      onClick={disabled ? () => {} : () => navigate(`/integrations${route}`)}
      data-cy={`card-${route.replace('/', '')}`}
    >
      <div className='flex items-center justify-between'>
        <span className=''>{icon}</span>
        {disabled && (
          <Badge className='!opacity-100' variant='outline'>
            {t('coming_soon')}
          </Badge>
        )}
      </div>
      <h2 className='text-sm mt-4 mb-3'>{title}</h2>
      <p className='text-muted text-xs -mt-2'>{description}</p>
    </div>
  );
}
